import React from "react";


export const ChecklistProgram: React.FC<{
    name: string;
    className?: string;
}> = ({ name, className }) => {
    return (
        <div className='mx-8 my-2 ml-6'>
            <div className={'flex items-center mx-4' + className}>
                <img 
                src="/img/lms/Check-Lms.png" 
                alt="Checklist" 
                className="w-4 h-4 mr-2 group-hover:hidden" 
                />
                <img 
                src="/img/lms/Check-hover.png" 
                alt="Checklist" 
                className="w-4 h-4 mr-2 hidden group-hover:block" 
                />
                <span className="transition-colors duration-300">{name}</span>
            </div>
        </div>
    )
}